import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import doneGrey from "../../../public/svgs/done-grey.svg";
function DoneGreyIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={doneGrey} alt="done grey icon" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default DoneGreyIcon;